<!-- FIXME: <ngx-slim-loading-bar [color]="'#99d2ec'"></ngx-slim-loading-bar> -->
<div id="wrapper">
  <!-- Navbar -->
  <nav class="nav-main">
    <div class="container">
      <div class="flex-container">

        <!-- Left side logo -->
        <div class="header-logo">
          <a routerLink="/">
            <img class="logo-top"
              [src]="currentUser?.THEME_NIGHT ? '/assets/images/header-logo-white.png' : '/assets/images/header-logo.png'"
              alt="Reliant Business Valuation" />
          </a>
        </div>

        <!-- Right side menu's -->
        <div class="header-controls">

          <a class="control-item link" [routerLink]="['/dashboard']" routerLinkActive="active">
            <fa name="fa fa-home"></fa>
            <div class="item">Dashboard</div>
          </a>

          <a class="control-item link" [routerLink]="['/processing']" routerLinkActive="active" *ngIf="isCoreAccess()">
            <fa name="fa fa-quora"></fa>
            <div class="item">Quotes <span style="color: orange; font-weight: 600;">({{totalQuotes}})</span> </div>
          </a>

          <a *ngIf="isAnyDefaultBoard() && isCoreAccess()" class="control-item link"
            [routerLink]="['/boards/' + defaultBoard.ID]" routerLinkActive="active">
            <fa *ngIf="!defaultBoard.SHARED" name="fa fa-list-alt"></fa>
            <fa *ngIf="defaultBoard.SHARED" name="fa fa-share-square-o"></fa>
            <div class="item">{{defaultBoard.NAME}}</div>
          </a>

          <div class="manage control-item link" dropdown dropdownToggle placement="bottom right" *ngIf="isCoreAccess()">
            <fa name="fa fa-clipboard"></fa>
            <div class="item">Boards</div>

            <div class="drop-menu dropdown-menu-right" *dropdownMenu>
              <ng-container *ngIf="boards.length > 0">
                <a class="drop-item board" *ngFor="let item of boards" routerLinkActive="active">
                  <div [routerLink]="['/boards/' + item.ID]" class="board-name">
                    <fa *ngIf="!item.SHARED" name="fa fa-clipboard"></fa>
                    <fa *ngIf="item.SHARED" name="fa fa-share-square-o"></fa>
                    <div class="item">{{item.NAME}}</div>
                  </div>
                  <div class="board-action">
                    <ng-container *ngIf="!item.SHARED">
                      <fa *ngIf="!item.IS_DEFAULT" name="fa fa-star-o" (click)="onSetDefault($event, item)"></fa>
                      <fa *ngIf="item.IS_DEFAULT" name="fa fa-star" (click)="onSetDefault($event, item)"></fa>
                    </ng-container>
                    <fa name="fa fa-trash" class="ml-2" style="width: 15px;color: red;"
                      (click)="onDeleteBoard($event, item)"></fa>
                  </div>
                </a>
              </ng-container>
              <a class="drop-item" (click)="createNewBoard()" routerLinkActive="active">
                <fa name="fa fa-plus"></fa>
                <div class="item">Create New Board</div>
              </a>
              <a class="drop-item" [routerLink]="['/features']" routerLinkActive="active">
                <fa name="fa fa-share-square-o"></fa>
                <div class="item">Feature Board</div>
              </a>
            </div>
          </div>

          <a class="control-item link" [routerLink]="['/statistics']" routerLinkActive="active" *ngIf="isCoreAccess()">
            <fa name="fa fa-line-chart"></fa>
            <div class="item">Statistics</div>
          </a>

          <!-- Reporting -->
          <a class="manage control-item link" dropdown dropdownToggle placement="bottom right" *ngIf="isCoreAccess()">
            <fa name="fa fa-inbox"></fa>
            <div class="item">Reporting</div>

            <div class="drop-menu dropdown-menu-right" *dropdownMenu>
              <a class="drop-item" [routerLink]="['/reporting/advance']" routerLinkActive="active">
                <fa name="fa fa-building-o"></fa>
                <div class="item">Advance Reporting Orders</div>
              </a>

              <a class="drop-item" [routerLink]="['/reporting/static']" routerLinkActive="active">
                <fa name="fa fa-history"></fa>
                <div class="item">Static Reporting</div>
              </a>
              <a class="drop-item" [routerLink]="['/reporting/quote-advance']" routerLinkActive="active">
                <fa name="fa fa-building-o"></fa>
                <div class="item">Advanced Reporting Quotes</div>
              </a>
              <a class="drop-item" [routerLink]="['/reporting/errors']" routerLinkActive="active">
                <fa name="fa fa-building-o"></fa>
                <div class="item">Reporting Errors</div>
              </a>
              <a class="drop-item" [routerLink]="['/reporting/tier-rating']" routerLinkActive="active">
                <fa name="fa fa-building-o"></fa>
                <div class="item">Tier and Rating</div>
              </a>

              <a class="drop-item" [routerLink]="['/reporting/drop-off-report']" routerLinkActive="active">
                <fa name="fa fa-building-o"></fa>
                <div class="item">Drop Off Report</div>
              </a>

              <a class="drop-item" [routerLink]="['/reporting/industry-usage']" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">Top Industry Usage</div>
              </a>

            </div>
          </a>

          <!-- Manage -->
          <div class="manage control-item link" dropdown dropdownToggle placement="bottom right" *ngIf="isCoreAccess()">
            <fa name="fa fa-cog"></fa>
            <div class="item">Manage</div>

            <div class="drop-menu dropdown-menu-right" *dropdownMenu>
              <!-- Clients -->
              <a class="drop-item" [routerLink]="['/manage/client']" routerLinkActive="active">
                <fa name="fa fa-building-o"></fa>
                <div class="item">Clients</div>
              </a>

              <!-- Clinet Users -->
              <a class="drop-item" [routerLink]="['/manage/client-user']" routerLinkActive="active">
                <fa name="fa fa-users"></fa>
                <div class="item">Client Users</div>
              </a>

              <!-- Tags -->
              <a class="drop-item" [routerLink]="['/manage/tags']" routerLinkActive="active">
                <fa name="fa fa-tags"></fa>
                <div class="item">Tags</div>
              </a>

              <!-- Holidays -->
              <a class="drop-item" [routerLink]="['/manage/holidays']" routerLinkActive="active">
                <fa name="fa fa-calendar"></fa>
                <div class="item">Holidays</div>
              </a>

              <!-- Export Template -->
              <a class="drop-item" [routerLink]="['/manage/template-builders']" routerLinkActive="active">
                <fa name="fa fa-upload"></fa>
                <div class="item">Export Template</div>
              </a>

              <!-- Access Management -->
              <a class="drop-item" [routerLink]="['/manage/acl']" routerLinkActive="active">
                <fa name="fa fa-key"></fa>
                <div class="item">Access Management</div>
              </a>

              <!-- Automation -->
              <a class="drop-item" [routerLink]="['/manage/automation']" routerLinkActive="active">
                <fa name="fa fa-magic"></fa>
                <div class="item">Automations</div>
              </a>

              <!-- Canned Response -->
              <a class="drop-item" [routerLink]="['/manage/canned-response']" routerLinkActive="active">
                <fa name="fa fa-envelope-o"></fa>
                <div class="item">Canned Response</div>
              </a>

              <!-- Industry Matrix -->
              <a class="drop-item" [routerLink]="['/manage/matrix']" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">Industry Matrix</div>
              </a>

              <!-- Reaserch -->
              <a class="drop-item" [routerLink]="['/manage/research/blurbs']" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">Research Blurbs</div>
              </a>
              <a class="drop-item" [routerLink]="['/manage/research/ibis']" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">IBIS Databases</div>
              </a>
              <a class="drop-item" [routerLink]="['/manage/research/pnc']" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">PNC Reports</div>
              </a>
              <a class="drop-item" [routerLink]="['/manage/franchise']" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">Franchise</div>
              </a>

              <a class="drop-item" [routerLink]="['/manage/database/dealstats']" routerLinkActive="active">
                <fa name="fa fa-database"></fa>
                <div class="item">DealStats Database</div>
              </a>

              <a class="drop-item" [routerLink]="['/manage/database/bizcomps']" routerLinkActive="active">
                <fa name="fa fa-database"></fa>
                <div class="item">BizComps Database</div>
              </a>
              <a class="drop-item" (click)="openRma()" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">RMA Parser</div>
              </a>
              <a class="drop-item" (click)="openRot()" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">Rot Parser</div>
              </a>

              <a class="drop-item" (click)="openBizcomps()" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">Bizcomps Parser</div>
              </a>

              <a class="drop-item" (click)="openDealState()" routerLinkActive="active">
                <fa name="fa fa-industry"></fa>
                <div class="item">Dealstats Parser</div>
              </a>

              <a class="drop-item" [routerLink]="['/manage/questions']" routerLinkActive="active">
                <fa name="fa fa-database"></fa>
                <div class="item">Questions Bank</div>
              </a>

            </div>
          </div>

          <div class="navigator control-item" dropdown dropdownToggle placement="bottom right" *ngIf="isCoreAccess()">
            <div class="drop-menu dropdown-menu-right" *dropdownMenu>
              <ng-container *ngIf="recentReports?.length > 0">
                <a class="drop-item" *ngFor="let recent of recentReports"
                  [routerLink]="['/report', recent.ID, 'general']" routerLinkActive="active">
                  <fa name="fa fa-file-text-o"></fa>
                  <div class="item">
                    {{recent.COMPANY_NAME ? recent.COMPANY_NAME : "("+recent.ID+") No Company Report"}}
                  </div>
                </a>
              </ng-container>

              <ng-container *ngIf="recentReports?.length === 0">
                <div class="drop-header">
                  No Recent Reports
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Mode -->
          <div *ngIf="isEaAccess()" class="switcher control-item" (click)="switchModes()">
            <div class="system-type" *ngIf="currentMode === Mode.BV">BV</div>
            <div class="system-type" *ngIf="currentMode === Mode.EA">EA</div>
          </div>

          <div class="user control-item" dropdown dropdownToggle placement="bottom right">

            <span class="loading-icon-small" *ngIf="avatarLoading"></span>

            <custom-avatar *ngIf="!avatarLoading" [id]="currentUser?.ID" [url]="currentUser?.AVATAR_URL"
              [name]="currentUser?.getName()" [color]="currentUser?.AVATAR_COLOR" size="32"></custom-avatar>

            <div class="chrome-app-error hinted" *ngIf="!chromeAppInstalled">
              <fa name="fa fa-exclamation-triangle"></fa>
              <div class="hint">File System API Disabled</div>
            </div>

            <div class="drop-menu dropdown-menu-right" *dropdownMenu>
              <a class="drop-header" [routerLink]="['/account']">
                <custom-avatar *ngIf="!avatarLoading" [id]="user?.ID" [url]="currentUser?.AVATAR_URL"
                  [name]="currentUser?.getName()" [color]="currentUser?.AVATAR_COLOR" size="48"></custom-avatar>

                <div class="user-name">{{currentUser?.getName()}}</div>
                <div class="user-email">{{currentUser?.EMAIL}}</div>
              </a>

              <a class="drop-item" *ngIf="!chromeAppInstalled" [routerLink]="['/extension']">
                <fa name="fa fa-exclamation-triangle" style="color: orange;"></fa>
                <div class="item">Enable File System API</div>
              </a>

              <a class="drop-item" [routerLink]="['/account']">
                <fa name="fa fa-sliders"></fa>
                <div class="item">Account settings</div>
              </a>

              <a class="drop-item">
                <fa name="fa fa-sign-out"></fa>
                <div class="item" (click)="signOut()">Sign out</div>
              </a>

            </div>
          </div>

          <a class="control-item link">
            <app-report-an-issue></app-report-an-issue>
          </a>

        </div>

      </div>
    </div>
  </nav>

  <!-- Side notes  -->
  <side-notes></side-notes>


  <!-- Toaster messages -->
  <app-toast></app-toast>

  <!-- Pages -->
  <router-outlet></router-outlet>
</div>

<!-- Footer -->
<footer class="footer">
  <div class="container">
    © {{currentYear}} Reliant Business Valuation, LLC | All rights Reserved
    <span style="float: right;"><strong>App:</strong>&nbsp;<app-version></app-version>&nbsp;<strong>Angular:
      </strong>{{angularVersion}}</span>
  </div>
</footer>